import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  details:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
    margin: "32px 0 0"
  },
  title:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    color: colors.lightBlack,
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px"
  },
  subtitle: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginBottom: "32px"
    }
  }
});

export default styles;
